const LOCATION_POPUP_KEY = 'locationChangePopupLastShown'
const COOLDOWN_PERIOD_MS = 30 * 60 * 1000

export function useLocationStorage() {
    const savePopupShownData = (lat: number, lng: number) => {
        localStorage.setItem(
            LOCATION_POPUP_KEY,
            JSON.stringify({ timestamp: Date.now(), lat, lng })
        )
    }

    const getLastPopupShownData = () => {
        try {
            const stored = localStorage.getItem(LOCATION_POPUP_KEY)
            return stored ? JSON.parse(stored) : null
        } catch {
            return null
        }
    }

    const hasCooldownPassed = () => {
        const last = getLastPopupShownData()?.timestamp
        return !last || Date.now() - last >= COOLDOWN_PERIOD_MS
    }

    return {
        savePopupShownData,
        getLastPopupShownData,
        hasCooldownPassed
    }
}
